import { CloseWhite, close, search } from "helper/icons";
import { useRef, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { IconButton } from "shared/Components/iconButton";

export const SearchDropdown = (props) => {
  const {
    label,
    placeholder,
    errorMsg,
    showCancel = true,
    width = "w-[358px] lg:w-[384px] max-[400px]:w-[100%]",
    dropdownOptions = [],
    onSelectOption,
    onChangeSearchText,
    isShowClearButton = false,
    onClickClearButton,
    defaultValue = "",
    isFaded = false,
    height,
    disabled = false,
    decoratedValue = (value) => value,
    isShadow = false,
    onBlur,
  } = props || {};

  const [searchTerm, setSearchTerm] = useState("");
  const [isShowMenu, setIsShowMenu] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0, width: 0 });
  const inputRef = useRef(null);
  const portalRef = useRef(null);

  useEffect(() => {
    setSearchTerm(defaultValue === null ? "" : defaultValue);
  }, [defaultValue]);

  // Close menu when clicking outside both the input and the portal dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInput = inputRef.current && inputRef.current.contains(event.target);
      const clickedPortal = portalRef.current && portalRef.current.contains(event.target);
      if (!clickedInput && !clickedPortal) {
        setIsShowMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectOption = (option, index) => {
    setIsShowMenu(false);
    setSearchTerm(decoratedValue(option));
    onSelectOption?.(option, index);
  };

  function handleClearRequest() {
    setIsShowMenu(false);
    setSearchTerm("");
    onSelectOption?.();
  }

  const handleInputChange = (event) => {
    const value = event.target.value;
    onChangeSearchText(value, placeholder);
    setSearchTerm(value);
  };

  const openMenu = () => {
    if (inputRef.current) {
      const rect = inputRef.current.getBoundingClientRect();
      setDropdownPos({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }
    setIsShowMenu(true);
  };

  return (
    <div className={`relative flex flex-col ${width}`}>
      {!!label && (
        <div className="mb-0.5">
          <span className="text-gray-700 font-medium text-sm">{label}</span>
        </div>
      )}
      <div
        className={`flex flex-row gap-2 ${label ? `mt-1` : ""} flex-1 items-stretch relative`}
      >
        <div className="flex row flex-1 flex-grow relative w-full">
          <input
            autoComplete="off"
            placeholder={placeholder}
            value={searchTerm}
            className={`${height} w-full rounded-md ${!!isShadow && "shadow-100"} border ${
              errorMsg ? "border-red" : "border-gray-300"
            } py-2.5 pl-3.5 pr-10 ${
              disabled ? "text-gray-900/50" : "text-gray-900"
            } font-inter font-normal text-base inputFocus focus:outline-none bg-white`}
            ref={inputRef}
            onChange={handleInputChange}
                    onFocus={openMenu}
            onBlur={() => onBlur && onBlur(searchTerm)}
            disabled={disabled}
          />
          {searchTerm && showCancel && !disabled ? (
            <img
              onClick={handleClearRequest}
              src={close}
              alt=""
              height={20}
              width={20}
              className="absolute top-3 right-4 cursor-pointer"
            />
          ) : (
            <img
              src={search}
              alt=""
              height={20}
              width={20}
              className="absolute top-3 right-4"
            />
          )}
        </div>
        {isShowClearButton && (
          <IconButton
            icon={CloseWhite}
            width={"w-[40px]"}
            onClick={onClickClearButton}
          />
        )}
        {isShowMenu && dropdownOptions.length > 0 && ReactDOM.createPortal(
          <div
            ref={portalRef}
            style={{
              position: "absolute",
              top: dropdownPos.top + 4,
              left: dropdownPos.left,
              width: dropdownPos.width,
              zIndex: 99999,
            }}
            className="rounded-md shadow-100 bg-white max-h-52 overflow-auto"
          >
            <div className="py-1" role="menu" aria-orientation="vertical">
              {dropdownOptions.map((option, index) => (
                <button
                  key={option}
                  onMouseDown={(e) => {
                    // Use mousedown instead of click so it fires before the input's onBlur
                    e.preventDefault();
                    selectOption(option, index);
                  }}
                  className={`block w-full text-left px-4 py-4 text-sm text-gray-700 hover:bg-primary/50 hover:text-white ${
                    index !== dropdownOptions.length - 1 ? "border-b border-purple-100" : ""
                  } border-gray-200`}
                  role="menuitem"
                >
                  {option}
                </button>
              ))}
            </div>
          </div>,
          document.body
        )}
      </div>

      {!!errorMsg && (
        <span className="text-red font-medium text-sm mt-1 pt-2">
          {errorMsg}
        </span>
      )}
    </div>
  );
};
